import { render, staticRenderFns } from "./Sm400Gray.vue?vue&type=template&id=0bc4585d&scoped=true&"
var script = {}
import style0 from "./Sm400Gray.vue?vue&type=style&index=0&id=0bc4585d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4585d",
  null
  
)

export default component.exports